import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Card/card.mjs';
export const CardSelectableActions = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (_jsx("div", Object.assign({ className: css(styles.cardSelectableActions, className) }, props, { children: children })));
};
CardSelectableActions.displayName = 'CardSelectableActions';
//# sourceMappingURL=CardSelectableActions.js.map